<template>
    <div class="mx-4">
        <div v-if="!hideHeader" class="row px-5 font-weight-bold text-muted">
            <div class="col-md-4">
                {{ __('subscriptions.feature') }}
            </div>
            <div class="col-md-2 text-md-center">
                {{ __('general.type') }}
            </div>
            <div v-if="Permission.EDIT_SUBSCRIPTION_FEATURES" class="col-md-2 text-md-center">
                {{ __('general.prices') }}
            </div>
            <div v-if="Permission.EDIT_SUBSCRIPTION_FEATURES" class="col-md-2 text-md-center">
                {{ __('subscriptions.bundles') }}
            </div>
            <div v-if="Permission.EDIT_SUBSCRIPTION_FEATURES" class="col-md-2 text-md-right">
                {{ __('general.actions') }}
            </div>
        </div>

        <div v-for="feature in features"
             class="row bg-light-light bg-hover-light-primary rounded mt-2 p-5"
             :class="{'mt-2': !hideHeader}">
            <Center vertical class="col-md-4">
                <Productable :productable="feature" :plain="plain"/>
            </Center>
            <Center vertical class="col-md-2 text-md-center text-muted">
                {{ __('subscriptions.feature_types.' + feature.type) }}
            </Center>
            <Center v-if="Permission.EDIT_SUBSCRIPTION_FEATURES" vertical class="col-md-2 text-md-center">
                {{ feature.pricings.length }}
            </Center>
            <Center v-if="Permission.EDIT_SUBSCRIPTION_FEATURES" vertical class="col-md-2 text-md-center">
                <Link :href="$route('subscriptions.bundles', {highlight: feature.id})" as="a">
                    {{ feature.bundles_count }} {{ __('subscriptions.bundles') }}
                </Link>
            </Center>
            <Center v-if="Permission.EDIT_SUBSCRIPTION_FEATURES" vertical class="col-md-2">
                <div class="btn-group btn-group-sm">
                    <Link as="button"
                          class="btn btn-sm btn-light-primary btn-hover-primary"
                          :href="$route('subscriptions.features.edit', feature.id)">
                        <i class="fas fa-edit"/>
                        {{ __('actions.edit') }}
                    </Link>
                </div>
            </Center>
        </div>
    </div>
</template>

<script>
import {Link} from '@inertiajs/vue2';
import {PermissionsMixin} from '@js/permissions';
import Productable from "@components/Subscriptions/Productable.vue";
import Center from "@components/Layout/Center.vue";

export default {
    components: {Productable, Center, Link},

    mixins: [PermissionsMixin],

    props: {
        features: Array,
        plain: Boolean,
        hideHeader: Boolean,
    }
}
</script>
